var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.notificationsEnabled)?_c('v-icon',[_vm._v(_vm._s(_vm.mdiBell))]):_c('v-icon',[_vm._v(_vm._s(_vm.mdiBellOff))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }